import { ResendPartnerOnboardingIDVerificationEmailRequest } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useResendOnboardingIDVerificationEmail() {
  const [resendingOnboardingIDVerificationEmail, setResendingOnboardingIDVerificationEmail] = useState(false);

  async function resendOnboardingIDVerificationEmail(params: ResendPartnerOnboardingIDVerificationEmailRequest) {
    try {
      setResendingOnboardingIDVerificationEmail(true);
      const res = await api.resendPartnerOnboardingIDVerificationEmail(params);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setResendingOnboardingIDVerificationEmail(false);
    }
  }

  return { resendingOnboardingIDVerificationEmail, resendOnboardingIDVerificationEmail };
}
